module.exports = __webpack_public_path__ + "img/laporan.cd2fe36c.svg";